import { Concessionaire } from "models/Concessionaire";
import { ConcessionaireProps } from "models/types";
import { BaseServices } from "./baseServices";

export class ConcessionaireService extends BaseServices<ConcessionaireProps, Concessionaire> {
	constructor() {
		super(Concessionaire);
	}

	async listAll() {
		return this.list("concessionaires", { params: { sort: "name,asc" } });
	}

	static getInstance() {
		return new ConcessionaireService();
	}
}
